import React from 'react';
import {
    Typography,
    Divider,
    Button,
    Card,
} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import ShareIcon from '@mui/icons-material/Share';
import CardMedia from '@mui/material/CardMedia';
import A8AdMyVision from '../../components/A8/A8AdMyVision';
import CATEGORY_IMAGE from '../../../static/biz-professional/black-4480596_1280.jpeg';
import { useNavigate } from 'react-router-dom';

interface ArticlePageProps {
    path: string;
}


const Article: React.FC<ArticlePageProps> = ({ path }) => {
    const handleCopyClick = () => {
        navigator.clipboard.writeText(path)
            .then(() => {
                console.log('Link copied to clipboard!');
            })
            .catch((err) => {
                console.error('Unable to copy link to clipboard', err);
            });
    };

    const navigate = useNavigate()
    const handleImageClick = (path: string) => {
        navigate(path);
        window.scrollTo(0, 0);
    };
    return (
        <div>
            <Box sx={{ mt: 7, mb: 12, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                <Card elevation={0} sx={{ maxWidth: 1000 }} style={{ margin: '0px', padding: '5px' }}>
                    <CardContent>
                        <Typography variant="h1" id="introduction" style={{ fontSize: '30px' }}>
                            エピローグ: 監修者からのメッセージ
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Typography variant="body2" color="text.primary">
                            Published on 2024 Jan 17th <br />
                            1 min read  <br />
                            by Michelle
                        </Typography>
                    </CardContent>
                    <CardContent>
                        <Button variant="text" size="small" endIcon={<ShareIcon />} style={{ color: 'black' }} onClick={handleCopyClick}>
                            Copy URL of this ariticle
                        </Button>
                    </CardContent>
                    <CardMedia
                        component="img"
                        height="500"
                        sx={{

                            objectFit: 'cover',
                            filter: 'grayscale(90%)',
                        }}
                        image={CATEGORY_IMAGE}
                        alt="image of the category"
                    />
                    <CardContent>
                        <Typography variant="body2" color="text.secondary">
                            エピローグ: 監修者からのメッセージ
                        </Typography>
                    </CardContent>
                    <Divider style={{ margin: '20px 0' }} />

                    <CardContent>
                        <Typography variant="h5">

                            人類の知識が驚くほどの勢いで発展することに高揚を覚える一方で、現代は未だ社会課題に溢れています。<br /><br />

                            私が戦略コンサルティングファームの世界に飛び込んだのは、混沌とする世の中に少しでも貢献できたらという思いがあったからです。<br /><br />

                            そんな中、複雑化する社会の課題に真摯に向き合う研究者やエンジニア、ビジネスマンを含む種々のプロフェッショナルが、伝える能力が低いために重要なプロジェクトを推し進めることが出来ない場面に数多く遭遇しました。社会として大きな損失です。<br /><br />

                            プレゼンテーションスキルというと、社会課題解決とはほど遠く、ましてやそれに求められるスキルのほんの一片のように聞こえるかもしれませんが、実は本質的に重要なスキルの一つです。<br /><br />

                            本サイトを通じて、多くのエキスパートが人を魅了するメッセージを発信できるようになり、転じて数多くの組織が社会に対してより本質的な価値を提供できるようになることが、私たちの願いです。<br /><br />

                        </Typography>
                    </CardContent>

                    <Divider style={{ margin: '20px 0' }} />
                    <CardContent>
                        <A8AdMyVision />
                    </CardContent>
                    <Button
                        variant="text"
                        size="small"
                        endIcon={<ShareIcon />}
                        style={{ color: 'black' }}
                        onClick={() => handleImageClick("/")}
                    >
                        他のプレゼンテーションスキルを学ぶ（記事一覧へ）
                    </Button>
                </Card>
            </Box>
        </div>
    );
};

export default Article;
